import { IState } from "store/index";

export const userIdSelector = (state: IState) => state.app.auth.id;
export const permissionsSelector = (state: IState) =>
  state.app.auth.permissions;
export const isLoadingSelector = (state: IState) => state.app.auth.isLoading;
export const errorSelector = (state: IState) => state.app.auth.error;
